export { AssetTable } from "./AssetTable";
